import React from 'react';
import { useIntl } from 'react-intl';

import { getCountBaskets } from '@/entities/cart';

import { useAppSelector } from '@/shared/hooks/appRedux';

import { TitleCartSplit, YouOrder } from './parts';

const ContentHeader: React.FC = () => {
  const countBaskets = useAppSelector(getCountBaskets);
  const { formatMessage } = useIntl();
  const messages = {
    yourOrder: formatMessage({ id: 'YourCart' }),
    yourCartSplit: formatMessage({ id: 'YourCartSplit' }, { 0: countBaskets }),
  };

  return (
    <>
      <YouOrder dangerouslySetInnerHTML={{ __html: messages.yourOrder }} />
      {countBaskets > 1 && (
        <TitleCartSplit dangerouslySetInnerHTML={{ __html: messages.yourCartSplit }} />
      )}
    </>
  );
};
export default ContentHeader;
